export const formatRows = (listaItems) =>
    listaItems.map((item) => ({
      id: item.id || "Id no disponible",
      tal_descripcion: item.tal_descripcion || "Talle no disponible",
    }));
  